export default "__VITE_ASSET__8cb58baf__"